import TaskList from './TaskList';
import TaskKanban from './TaskKanban';

function TasksBoard({
    heading,
    tasksView,
    tasksBusy,
    tasks,
    companyUsers,
    taskStatusLabels,
    getWorkspaceById,
    getUserLabel,
    onOpenTask,
    kanbanColumns,
    kanbanGroup,
    getInitials,
    onDragStart,
    onDrop
}) {
    return (
        <div className="tasks__list">
            <div className="tasks__head">
                <h4>{tasksView === 'list' ? heading : 'Канбан'}</h4>
            </div>
            {tasksBusy ? (
                <div className="loading">
                    <span className="spinner" aria-hidden="true" />
                    <span>Загрузка задач...</span>
                </div>
            ) : tasks.length === 0 ? (
                <div className="empty">Задачи пока не созданы.</div>
            ) : tasksView === 'list' ? (
                <TaskList
                    tasks={tasks}
                    companyUsers={companyUsers}
                    taskStatusLabels={taskStatusLabels}
                    getWorkspaceById={getWorkspaceById}
                    getUserLabel={getUserLabel}
                    onOpenTask={onOpenTask}
                />
            ) : (
                <TaskKanban
                    kanbanColumns={kanbanColumns}
                    kanbanGroup={kanbanGroup}
                    companyUsers={companyUsers}
                    getUserLabel={getUserLabel}
                    getInitials={getInitials}
                    onOpenTask={onOpenTask}
                    onDragStart={onDragStart}
                    onDrop={onDrop}
                />
            )}
        </div>
    );
}

export default TasksBoard;
